module.exports = __webpack_public_path__ + "static/media/vencimiento_rojo.6812f8dd.svg";